export function getTelLinkIfMobile(clickUrl) {
  if (!clickUrl) return clickUrl;
  // Remove spaces and dashes
  const cleaned = clickUrl.replace(/[\s\-]/g, '');
  // Match 10 digits or +91 followed by 10 digits
  const match = cleaned.match(/^(\+91)?(\d{10})$/);
  if (match) {
    // Always use just the 10 digits for tel:
    return `tel:${match[2]}`;
  }
  return clickUrl;
} 